import styled from "styled-components";

export const UserInfoEditModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 33px;

  p {
    text-align: center;
    font-size: 1.4rem;
    font-weight: 500;
  }
`;
